import { useState, useCallback, useEffect } from 'react';
import InstagramApiService from '../services/InstagramApiService';

const useInstagramAccount = (agentId) => {
  const [account, setAccount] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchStatus = useCallback(async () => {
    if (!agentId) return;
    setLoading(true);
    setError(null);
    try {
      const resp = await InstagramApiService.getStatus(agentId);
      setAccount(resp.data?.connected ? resp.data : null);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  }, [agentId]);

  const oauthStart = useCallback(async () => {
    const resp = await InstagramApiService.oauthStart(agentId);
    return resp.data;
  }, [agentId]);

  const togglePaused = useCallback(
    async (paused) => {
      const resp = await InstagramApiService.update(agentId, {
        bot_paused: paused,
      });
      setAccount(resp.data);
      return resp.data;
    },
    [agentId],
  );

  const refreshProfile = useCallback(async () => {
    const resp = await InstagramApiService.update(agentId, {
      refresh_profile: true,
    });
    setAccount(resp.data);
    return resp.data;
  }, [agentId]);

  const disconnect = useCallback(async () => {
    await InstagramApiService.disconnect(agentId);
    setAccount(null);
  }, [agentId]);

  useEffect(() => {
    fetchStatus();
  }, [fetchStatus]);

  return {
    account,
    loading,
    error,
    fetchStatus,
    oauthStart,
    togglePaused,
    refreshProfile,
    disconnect,
  };
};

export default useInstagramAccount;
